import React, { useEffect, useState } from "react";
import TController from "./components/create/TController";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import Box from "@mui/material/Box/Box";
import ChildHeader from "../../../common/ChildHeader";
import {
  CustomButton,
  SaveButton,
  SubmitButton,
} from "../../../common/CustomButtons";

import useConfirm from "../../../common/useConfirm";
import CustomUploadButton from "../../../common/CustomUploadButton";
import { Loader } from "../../../common/Loader";
import { useAuth } from "../../../context/GlobalContext";
import { useQuery } from "../../../components/Control/useQuery";

const Create = () => {
  const [moduleData, setModuleData] = useState({
    processes: [],
  });
  const [render, setRender] = useState(false);
  const history = useHistory();
  const { state } = useAuth();
  const query = useQuery();
  const annual_month = query.get("annual_month");
  const rowId = query.get("rowId");
  const isView = query.get("isView") === "true" ? true : false;

  const { id } = useParams();
  const [DialogDeleteRow, confirmDeleteRow] = useConfirm(
    "DELETE",
    "Are you sure you want to delete Row?",
  );
  const [DialogAddRow, confirmAddRow] = useConfirm(
    "Add Row",
    "Are you sure you want to Add Row?",
  );
  const [DialogSubmit, confirmSubmit] = useConfirm(
    "Submit",
    "Are you sure you want to save this document?",
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (id === "undefined") {
      createTraining_id();
    }
  }, []);

  const createTraining_id = async () => {
    await axios
      .post(`/api/trainingRecordRoute/${rowId}/${annual_month}`, moduleData)
      .then((res) => {
        if (res.data.status === "success") {
          const attach_id = res?.data?._id;

          history.push(
            `/common/trainingRecord/${attach_id}?rowId=${rowId}&annual_month=${annual_month}`,
          );
          setRender((prev) => !prev);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/trainingRecordRoute/${id}`)
        .then((res) => {
          setModuleData(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  const handleSumbit = async (isSubmitted) => {
    const ans = await confirmSubmit();
    if (!ans) return;
    moduleData.isSubmitted = isSubmitted;
    moduleData.is_admin_request = "pending";
    moduleData.report_prepared_by = state.user?.name;
    // console.log(typeof id);

    if (id !== "undefined") {
      await axios
        .put(`/api/trainingRecordRoute/${id}`, moduleData)
        .then((res) => {
          if (res.data.status === "success") {
            alert("Updated Successfully");
          }
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post(`/api/trainingRecordRoute/${rowId}/${annual_month}`, moduleData)
        .then((res) => {
          if (res.data.status === "success") {
            alert("created Successfully");
            history.goBack();
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const handelDeleteRows = async (rowIdx) => {
    const ans = await confirmDeleteRow();
    if (!ans) return;
    let data = { ...moduleData };
    data.processes.splice(rowIdx, 1);
    setModuleData(data);
  };

  const uploadFile = async (e, id) => {
    if (!window.confirm("Are you sure you want upload this Files")) return;
    const files = e.target.files;
    if (!files) return;
    let formData = new FormData();
    for (const key of Object.keys(files)) {
      formData.append("files", files[key]);
    }
    setIsLoading(true);
    axios
      .patch(`/api/trainingRecordRoute/uploadFile/${id}`, formData)
      .then((res) => {
        if (res.data) {
          alert("document upload successly");
          setIsLoading(false);
          setRender((prev) => !prev);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  return (
    <>
      <Box>
        <ChildHeader text="Training">
          {!isView && (
            <>
              {id !== "undefined" && (
                <CustomUploadButton
                  id={id}
                  lable={"Attach Proof"}
                  accept="image/png,image/jpeg,image/jpg,application/pdf,.xlsx,.xls,.doc,.docx"
                  multiple={true}
                  onChange={(e) => {
                    uploadFile(e, id || "");
                  }}
                />
              )}
              <CustomButton
                sx={{
                  backgroundColor: "#1c7ed6",
                }}
                onClick={async () => {
                  const ans = await confirmAddRow();
                  if (!ans) return;
                  moduleData.processes.push({});
                  setRender((prev) => !prev);
                }}
              >
                ADD ROWS
              </CustomButton>
              {state.user?.userType === state.IS.Supervisor && (
                <SaveButton
                  label="Save & Continue"
                  onClick={() => handleSumbit(false)}
                />
              )}
              <SubmitButton
                type={"button"}
                label="Submit"
                onClick={() => handleSumbit(true)}
              />
            </>
          )}
        </ChildHeader>
      </Box>
      <Loader loader={isLoading} />
      <TController
        {...{
          moduleData,
          isView,
          handelDeleteRows,
        }}
      />

      <DialogDeleteRow isSubmitContent={false} />
      <DialogAddRow />
      <DialogSubmit />
    </>
  );
};

export default Create;
